import apiClient from './api';
import type { AnalyticsData, ActivityLog, PaginationParams } from '@/types';

export const analyticsService = {
  /**
   * Get analytics data
   */
  async getAnalytics(params?: { start_date?: string; end_date?: string }): Promise<AnalyticsData> {
    const { data } = await apiClient.get<AnalyticsData>('/analytics', { params });
    return data;
  },

  /**
   * Get dashboard statistics
   */
  async getDashboardStats() {
    const { data } = await apiClient.get('/dashboard/stats');
    return data;
  },

  /**
   * Get activity logs
   */
  async getActivityLogs(params?: PaginationParams) {
    const { data } = await apiClient.get<ActivityLog[]>('/activity-logs', { params });
    return data;
  },

  /**
   * Get login activity trends
   */
  async getLoginTrends(params?: { days?: number }) {
    const { data } = await apiClient.get('/analytics/login-trends', { params });
    return data;
  },

  /**
   * Get user growth metrics
   */
  async getUserGrowth(params?: { period?: string }) {
    const { data } = await apiClient.get('/analytics/user-growth', { params });
    return data;
  },

  /**
   * Get security metrics
   */
  async getSecurityMetrics() {
    const { data } = await apiClient.get('/analytics/security');
    return data;
  },
};
